import React from 'react'
import './index.css'
import Flex from 'components/Flex'
import FlexColumn from 'components/FlexColumn'
import TextSemiBold from 'components/TextSemiBold'
import Span from 'components/Span'
import Button from 'components/Button'
import classNames from 'classnames'
import useSelector from 'hooks/use-selector'
import getSubscriptionSellingPlanIdVariantSelector from 'modules/variant/redux/selectors/get-subscription-selling-plan-id'
import logEventAnalyticsUtil from 'utils/analytics/log-event'
import useDispatch from 'hooks/use-dispatch'
import updateSubscriptionSellingPlanIdVariantAction from 'modules/variant/redux/actions/update-subscription-selling-plan-id'
import PriceAndDiscountPrice from 'components/PriceAndDiscountPrice'
import getDiscountedPriceVariantSelector from 'modules/variant/redux/selectors/get-discounted-price'
import logUtil from 'utils/log'
import hasSubscriptionByVariantIdCartSelector from 'modules/cart/redux/selectors/has-subscription-by-variant-id'
import getPriceProductVariantUtil from 'modules/product-variant/utils/get-price'

const TITLE = 'One time purchase'

const ANALYTICS_EVENT = {
  SELECT_ONE_TIME_PURCHASE_IN_QUICK_SHOP: 'SELECT_ONE_TIME_PURCHASE_IN_QUICK_SHOP'
}
/**
 * @param props
 * @param {ProductVariantCollection} props.productVariant
 * @param {number} props.variantId
 * @return {JSX.Element}
 * @constructor
 */
export default function QuickShopProductSidebarDeliveryOneTimePurchaseButton (props) {
  const {
    productVariant,
    variantId
  } = props

  const dispatch = useDispatch()
  const price = getPriceProductVariantUtil(productVariant)
  const discountPrice = useSelector(
    getDiscountedPriceVariantSelector({
      variantId,
      price,
      ignoreSubscriptionDiscount: true,
      productVariant
    })
  )
  const hasSubscriptionForThisVariantInCart = useSelector(
    hasSubscriptionByVariantIdCartSelector(variantId)
  )

  const debugProps = {
    discountPrice,
    props,
    hasSubscriptionForThisVariantInCart
  }
  logUtil('QuickShopProductSidebarDeliveryOneTimePurchaseButton').debug('debugProps=', debugProps)
  const subscriptionSellingPlanId = useSelector(
    getSubscriptionSellingPlanIdVariantSelector(variantId)
  )

  const select = () => {
    dispatch(
      updateSubscriptionSellingPlanIdVariantAction({
        variantId,
        value: null
      })
    )
  }

  const handleClick = () => {
    logEventAnalyticsUtil(ANALYTICS_EVENT.SELECT_ONE_TIME_PURCHASE_IN_QUICK_SHOP)
    select()
  }

  const handleMount = () => {
    if (
      hasSubscriptionForThisVariantInCart ||
      subscriptionSellingPlanId
    ) {
      return
    }

    select()
  }

  const handleUnmount = () => {
    if (subscriptionSellingPlanId) {
      return
    }

    select()
  }

  React.useEffect(() => {
    handleMount()
    return handleUnmount
  }, [])

  return (
    <Button
      onClick={handleClick}
      className={
        classNames({
          'quick-shop-product-sidebar-delivery-one-time-purchase-button': true,
          'quick-shop-product-sidebar-delivery-one-time-purchase-button_selected': !subscriptionSellingPlanId
        })
      }
    >
      <svg
        width='40'
        height='40'
        viewBox='0 0 40 40'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <rect
          width='40'
          height='40'
          rx='6'
          fill='#F7F7F8'
        />
        <path
          d='M29.697 21.014C29.697 21.009 29.7 21.005 29.7 21C29.7 20.986 29.693 20.975 29.692 20.961C29.681 20.893 29.666 20.825 29.651 20.757C29.644 20.737 29.642 20.716 29.634 20.697C29.593 20.523 29.551 20.349 29.485 20.178L28.447 17.614C27.988 16.451 27.513 15.249 24.969 15.249H22.749V13.499C22.749 12.258 21.739 11.249 20.499 11.249H12.499C11.259 11.249 10.249 12.258 10.249 13.499V24.499C10.249 25.664 11.142 26.613 12.277 26.727C12.268 26.818 12.249 26.906 12.249 26.999C12.249 28.515 13.482 29.749 14.999 29.749C16.516 29.749 17.749 28.515 17.749 26.999C17.749 26.913 17.731 26.832 17.724 26.749H22.275C22.267 26.832 22.25 26.913 22.25 26.999C22.25 28.515 23.483 29.749 25 29.749C26.517 29.749 27.75 28.515 27.75 26.999C27.75 26.906 27.732 26.817 27.722 26.727C28.857 26.613 29.75 25.664 29.75 24.499V21.579C29.75 21.39 29.725 21.202 29.697 21.014ZM24.97 16.75C26.493 16.75 26.6351 17.107 27.0551 18.171L27.896 20.25H22.75V16.75H24.97ZM15 28.25C14.311 28.25 13.75 27.689 13.75 27C13.75 26.311 14.311 25.75 15 25.75C15.689 25.75 16.25 26.311 16.25 27C16.25 27.689 15.689 28.25 15 28.25ZM25 28.25C24.311 28.25 23.75 27.689 23.75 27C23.75 26.311 24.311 25.75 25 25.75C25.689 25.75 26.25 26.311 26.25 27C26.25 27.689 25.689 28.25 25 28.25ZM27.5 25.25H27.104C26.599 24.644 25.849 24.25 25 24.25C24.151 24.25 23.401 24.644 22.896 25.25H17.103C16.598 24.644 15.848 24.25 14.999 24.25C14.15 24.25 13.4 24.644 12.895 25.25H12.499C12.086 25.25 11.749 24.914 11.749 24.5V21.75H17.999C18.413 21.75 18.749 21.414 18.749 21C18.749 20.586 18.413 20.25 17.999 20.25H11.749V13.5C11.749 13.086 12.086 12.75 12.499 12.75H20.499C20.912 12.75 21.249 13.086 21.249 13.5V21.75H28.249V24.5C28.25 24.914 27.913 25.25 27.5 25.25Z'
          fill='#191531'
        />
      </svg>
      <FlexColumn
        className='quick-shop-product-sidebar-delivery-one-time-purchase-button-content'
      >
        <TextSemiBold
          className='quick-shop-product-sidebar-delivery-one-time-purchase-button-content-title'
        >
          {TITLE}
        </TextSemiBold>
        <Flex
          className='quick-shop-product-sidebar-delivery-one-time-purchase-button-content-price-and-recurrence'
        >
          <Span
            className='quick-shop-product-sidebar-delivery-one-time-purchase-button-content-price'
          >
            <PriceAndDiscountPrice
              price={price}
              discountPrice={discountPrice}
            />
          </Span>
        </Flex>
      </FlexColumn>
    </Button>
  )
}
